import { forwardRef } from "react";
import PropTypes from "prop-types";

const InputTextarea = forwardRef(
  ({ label, placeholder, error, name, details, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        {(label || details) && (
          <div className="flex justify-between items-center mb-1">
            {label && (
              <label
                htmlFor={name}
                className="text-base md:text-sm font-medium"
              >
                {label}
              </label>
            )}
            {details && <span className="text-xs md:text-xs">{details}</span>}
          </div>
        )}
        <textarea
          id={name}
          name={name}
          ref={ref}
          placeholder={placeholder}
          {...props}
          className={`w-full h-50 text-base md:text-sm px-4 py-2 input-base focus:outline-none transition resize-none ${
            error
              ? "border border-red-500 focus:ring-red-500 focus:border-red-500"
              : "border card-base-border focus:ring-blue-500 focus:border-blue-500"
          }`}
        />
        {error && <p className="text-xs text-red-500! mt-1">{error}</p>}
      </div>
    );
  }
);

InputTextarea.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  details: PropTypes.string,
};

InputTextarea.displayName = "InputTextarea";

export default InputTextarea;
